import React from 'react'
import './orderdetails.css'
import '../../index.css'
import { Container } from 'react-bootstrap'
import TermsconditionsVIdeo from '../../assets/video/Man_walking_to_his_villa.mp4'
import { Link } from 'react-router-dom'
import { AutoVideo } from "../../Components/AutoVideo"

const orderdetails = () => {
    return (
        <div>
            <div className='video-term reveal fade-in active'>
                <AutoVideo className="headervideo" src={TermsconditionsVIdeo}/>
                <Container>
                </Container>
            </div>
            <div className='position-relative'>
                <Container className='pt-5'>
                    <div className="header-wrapper">
                        <h1 className="header-text">Your Account</h1>
                    </div>

                    <nav className="nav nav-borders">
                        <Link to="/user-profile" className="nav-link ms-0">
                            Profile
                        </Link>
                        <Link to="/your-order" className="nav-link active ">
                            Orders
                        </Link>
                        <Link to="/save-item" className="nav-link">
                            Saved
                        </Link>
                    </nav>
                    <hr className="mt-0 mb-4" />
                    <div className="card mb-4">
                        <div className="card-header">Order Details</div>
                        <div className="card-body p-0">
                            <div className="table-responsive table-billing-history">
                                <div className='history'>
                                    <span>Order Id: 39201</span>
                                </div>
                                <div className='history'>
                                    <span>Date: 06/05/2022</span>
                                </div>
                                <div className='history'>
                                    <span>Total: $29.99</span>
                                </div>
                                <div className='history'>
                                    <span>Paid : $29.99</span>
                                </div>
                                <div className='history'>
                                    <span>Payment Date: 06/05/2022</span>
                                </div>
                                <div className='history'>
                                    <span>Payment Ref#: ch_f5g5fh54cn5645</span>
                                </div>
                                <div className='history'>
                                    <span>Payment Method: VISA ****3456</span>
                                </div>
                                <div className='download-invoice'>
                                    <button>Download Invoice</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default orderdetails